import React from 'react';
import { useTranslation } from 'react-i18next';
import { MatchFlowStatusEnum, PROGRESS_STATUS } from '../../../../../consts/enums';
import STRING_KEYS from '../../../../../language/keys';
import { MatchEngineWorkflowStatusEnum } from '../../../../../enums/match-engine-workflow-status.enum';
import { RunStatusCanceled } from './RunStatusCanceled';
import { RunStatusCompleted } from './RunStatusCompleted';
import { RunStatusError } from './RunStatusError';
import { RunStatusInProgress } from './RunStatusInProgress';
import { RunStatusNoResults } from './RunStatusNoResults';

type RunStatusContainerProps = {
  status: string | null,
  errorMessage: string,
  progress: number,
  matchEngineStatus: MatchEngineWorkflowStatusEnum,
  numberOfCreatedCandidates?: number,
  duplicateCandidatesSkipped?: number,
}

export const RunStatus = ({
  status,
  errorMessage,
  progress,
  matchEngineStatus,
  numberOfCreatedCandidates,
  duplicateCandidatesSkipped,
}:RunStatusContainerProps):JSX.Element | null => {
  // to do results should be taken from list ??
  const { t: translate } = useTranslation();

  switch (status) {
    case PROGRESS_STATUS.COMPLETED:
    case PROGRESS_STATUS.DEGRADED:
      if (!numberOfCreatedCandidates) {
        return (
          <RunStatusNoResults
            status={ status }
            duplicateCandidatesSkipped={ duplicateCandidatesSkipped }
          />
        );
      }

      return (
        <RunStatusCompleted
          numberOfCreatedCandidates={ numberOfCreatedCandidates || 0 }
          status={ status as MatchFlowStatusEnum }
          duplicateCandidatesSkipped={ duplicateCandidatesSkipped }
        />
      );
    case PROGRESS_STATUS.ERROR:
      return (
        <RunStatusError
          message={ errorMessage }
        />
      );
    case PROGRESS_STATUS.IN_PROGRESS:
      return <RunStatusInProgress progress={ progress } matchEngineStatus={ matchEngineStatus } />;
    case PROGRESS_STATUS.CANCELLED:
      return <RunStatusCanceled title={ translate(STRING_KEYS.SEARCH_RUN) } />;
    default:
      return null;
  }
};

RunStatus.defaultProps = {
  numberOfCreatedCandidates: undefined,
  duplicateCandidatesSkipped: undefined,
};
